import { Button, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../../../components/base/BasicDialog";

export const UpdateNoteDialog = (props) => {
    const { open, onClose, onUpdate } = props;
    const { t } = useTranslation();
    const [note, setNote] = useState("");

    const handleUpdate = () => {
        onUpdate(note);
        onClose();
    };

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("agreements.UpdateNoteDialog.title")}
            minWidth={800}
            maxWidth={"xl"}
            showDialogActions
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label={t("agreements.UpdateNoteDialog.noteLabel")}
                        multiline
                        rows={4}
                        fullWidth
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        onClick={handleUpdate}
                        disabled={note === ""}
                        variant="contained"
                        color="primary"
                    >
                        {t("agreements.UpdateNoteDialog.updateButton")}
                    </Button>
                </Grid>
            </Grid>
        </BasicDialog>
    );
};
